import {isNullOrUndefined} from "../../services/Validator";

function SystemTabletTopBarLayout({children, extraClass}) {
    // Used through the app to frame top bar in mobile mode

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"bg-backgroundLight1 w-full h-[64px] min-h-[64px] max-h-[64px] w-full hidden sm:flex lg:hidden justify-between items-center px-24 " + extraClass}>
            {children}
        </div>
    );
}

// EXPORT
export default SystemTabletTopBarLayout